import { render, staticRenderFns } from "./icon-plugin.vue?vue&type=template&id=55b47980&lang=pug&"
var script = {}
import style0 from "./icon-plugin.vue?vue&type=style&index=0&id=55b47980&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports